import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid vh-100 d-flex flex-column justify-content-center align-items-center">
      <h1 className="display-1">404</h1>
      <h2 className="mb-4">Page Not Found</h2>
      <p className="lead text-center">
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <button
        className="btn btn-primary mt-3"
        onClick={() => navigate("/home")}
      >
        Go to Home
      </button>
    </div>
  );
};

export default NotFound;
